<template>
  <div class="flex">
    <div class="vue_toogle_panels" @click="vueTooglePanels = !vueTooglePanels">
      <i class="material-icons">view_headline</i>
    </div>
    <div
      swichpanel="left"
      :class="['left_panel bright is-opened col-1360-over col-1360 col-768', (vueTooglePanels ? 'right_full': '')]"
    >
      <slot></slot>
    </div>
    <div
      :class="['right_panel is-opened  col-1360-over-rest col-1360-rest col-768-rest', (vueTooglePanels ? 'right_full': '')]"
    >
      <transition name="fade" mode="out-in">
        <router-view
          @update="e=>$emit('update',e)"
          @delete="e=>$emit('delete',e)"
          @removeContact="$emit('removeContact',$event)"
          @updateBusiness="$emit('updateBusiness',$event)"
        />
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "mar-panel-navigator",
  props: {
    gutter: {
      type: Number,
      default: 30
    }
  },
  data() {
    return { vueTooglePanels: false };
  }
};
</script>
<style >
.left_panel {
  position: relative;
  padding-top: 0px;
}
.right_panel {
  padding-left: 5px;
  height: calc(100vh - 62px);
  overflow: auto;
}
.vue_toogle_panels {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 50px;
  height: 60px;
  z-index: 1000;
  background: #095b69;
  color: #ffffff;
  text-align: center;
  padding-top: 10px;
  cursor: pointer;
}
.vue_toogle_panels .material-icons {
  font-size: 40px;
}
.flex {
  display: flex;
}
.col-1360-over {
  width: 25%;
  flex: 1 0 25%;
}
.col-1360-over-rest {
  width: 75%;
  flex: 1 0 75%;
}
.col-1360-over.right_full {
  width: 0%;
  flex: 1 0 0%;
}
.col-1360-over-rest.right_full {
  width: 100%;
  flex: 1 0 100%;
}
@media screen and (max-width: 1360px) {
  .col-1360 {
    width: 40%;
    flex: 1 0 40%;
  }
  .col-1360-rest {
    width: 60%;
    flex: 1 0 60%;
  }
  .col-1360.right_full {
    width: 0%;
    flex: 1 0 0%;
  }
  .col-1360-rest.right_full {
    width: 100%;
    flex: 1 0 100%;
  }
}
@media screen and (max-width: 768px) {
  .col-768 {
    width: 100%;
    flex: 1 0 100%;
  }
  .col-768-rest {
    width: 100%;
    flex: 1 0 100%;
  }
}
</style>